import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function AuthProvider({ children }) {
    // null = checking session, false = signed out, object = signed in
    const [user, setUser] = useState(null);

    useEffect(() => {
        let alive = true;
        axios
            .get(`${API}/api/auth/me`, { withCredentials: true })
            .then(({ data }) => {
                if (alive) setUser(data);
            })
            .catch(() => {
                if (alive) setUser(false);
            });
        return () => {
            alive = false;
        };
    }, []);

    const login = async (email, password) => {
        const { data } = await axios.post(`${API}/api/auth/login`, { email, password }, { withCredentials: true });
        setUser(data.user);
        return data.user;
    };

    const register = async (name, email, password) => {
        const { data } = await axios.post(`${API}/api/auth/register`, { name, email, password }, { withCredentials: true });
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true });
        } finally {
            setUser(false);
        }
    };

    return <AuthContext.Provider value={{ user, setUser, login, register, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
